export default function HeroSection() {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="hero"
      className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden bg-background-50"
    >
      {/* Background decoration */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-primary-100/30 rounded-full blur-3xl -translate-y-1/4 translate-x-1/4"></div>
        <div className="absolute bottom-0 left-0 w-[500px] h-[500px] bg-accent-100/30 rounded-full blur-3xl translate-y-1/3 -translate-x-1/4"></div>
      </div>

      <div className="relative w-full px-4 md:px-6 py-20 md:py-0">
        <div className="max-w-6xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          {/* Left content */}
          <div className="flex-1 w-full text-center lg:text-left pt-8 lg:pt-0">
            {/* Tag */}
            <div className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-primary-100 text-primary-700 rounded-full text-xs font-medium mb-6">
              <i className="ri-fire-line text-sm"></i>
              <span>实时热榜 · 24小时不间断更新</span>
            </div>

            {/* H1 */}
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 leading-tight mb-4">
              吃瓜黑料爆料
              <br />
              全网瓜友的吃瓜交流社区
            </h1>

            {/* Slogan */}
            <p className="text-lg md:text-xl text-primary-500 font-heading mb-6">
              来这里，吃最新鲜的瓜 🍉
            </p>

            {/* Description */}
            <div className="text-sm md:text-base text-foreground-600 leading-relaxed space-y-3 mb-8 max-w-xl mx-auto lg:mx-0">
              <p>
                吃瓜黑料爆料是国内领先的娱乐八卦讨论社区，汇聚黑料爆料贴吧网友分享与吃瓜群众实时交流。无论是娱乐圈最新小道消息、网红圈内幕揭秘，还是社交平台热议话题，这里都有第一手爆料资讯。
              </p>
              <p>
                平台每日更新海量热帖，覆盖明星动态、综艺争议、影视吐槽、网红八卦等多个板块，让每一位瓜友不错过任何精彩瞬间。
              </p>
            </div>

            {/* Stats */}
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              <div className="text-center">
                <div className="text-xl md:text-2xl font-bold text-foreground-950">200万+</div>
                <div className="text-xs text-foreground-500 mt-1">活跃瓜友</div>
              </div>
              <div className="w-px h-8 bg-background-300"></div>
              <div className="text-center">
                <div className="text-xl md:text-2xl font-bold text-foreground-950">50万+</div>
                <div className="text-xs text-foreground-500 mt-1">累计爆料帖</div>
              </div>
              <div className="w-px h-8 bg-background-300"></div>
              <div className="text-center">
                <div className="text-xl md:text-2xl font-bold text-accent-600">99.9%</div>
                <div className="text-xs text-foreground-500 mt-1">内容过审率</div>
              </div>
            </div>

            {/* CTAs */}
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#topics"
                onClick={(e) => handleClick(e, '#topics')}
                className="w-full sm:w-auto px-8 py-3 bg-primary-500 text-white font-medium text-sm rounded-lg hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap text-center cursor-pointer"
              >
                立即开始吃瓜
                <i className="ri-arrow-right-line ml-2"></i>
              </a>
              <a
                href="#ranking"
                onClick={(e) => handleClick(e, '#ranking')}
                className="w-full sm:w-auto px-8 py-3 bg-background-100 text-foreground-700 font-medium text-sm rounded-lg hover:bg-background-200 border border-background-200 transition-colors duration-200 whitespace-nowrap text-center cursor-pointer"
              >
                查看热搜榜单
                <i className="ri-bar-chart-line ml-2"></i>
              </a>
            </div>
          </div>

          {/* Right visual */}
          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-[480px] aspect-[4/5] rounded-2xl overflow-hidden bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=A%20vibrant%20warm-toned%20abstract%20illustration%20of%20a%20bustling%20Chinese%20social%20media%20community%20with%20floating%20speech%20bubbles%2C%20glowing%20hot%20topic%20icons%2C%20fire%20emoji-like%20decorations%2C%20and%20dynamic%20red-and-orange%20gradient%20background%20representing%20a%20lively%20entertainment%20gossip%20forum%2C%20modern%20and%20trendy%20design%20style%20with%20clean%20minimal%20layout%2C%20warm%20lighting%2C%20Chinese%20internet%20culture%20aesthetic&width=960&height=1200&seq=chigua-hero-2026&orientation=portrait"
                alt="吃瓜黑料爆料 - 娱乐八卦讨论社区主视觉"
                className="w-full h-full object-cover"
              />
              {/* Overlay decorations */}
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/60 to-transparent p-6">
                <div className="flex items-center gap-2 text-white/90 text-sm">
                  <div className="w-2 h-2 rounded-full bg-green-400 animate-pulse"></div>
                  <span>实时在线：128,537 人正在吃瓜</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}